module.exports = __webpack_public_path__ + "img/events.4ce016a3.svg";